import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DRIVERS_DOCUMENTS_DATA } from "./actionTypes";
import {
  fetchDriversDocumentsSuccess,
  fetchDriversDocumentsFailure,
} from "./actions";

function* fetchDriversDocumentsDataSaga(action) {
  try {
    const { page = 1, limit = 10, driverId } = action.payload || {};
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (driverId) params.set('driverId', String(driverId));
    const url = process.env.REACT_APP_WEB_APP_URL + `/api/web/drivers-documents?${params.toString()}`;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const payload = response.data;
    if (payload.total == null && Array.isArray(payload.data)) {
      payload.total = payload.data.length;
    }
    yield put(fetchDriversDocumentsSuccess(payload));
  } catch (error) {
    yield put(fetchDriversDocumentsFailure(error.message));
  }
}

export default function* driversDocumentsSaga() {
  yield takeEvery(FETCH_DRIVERS_DOCUMENTS_DATA, fetchDriversDocumentsDataSaga);
}
